module.exports = __webpack_public_path__ + "img/7.0304a3f1.jpg";